import { BorderedPill } from './BorderedPill';

export default BorderedPill;
